import { TextArea } from 'src/shared/design-system/Input';
import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Colors, Font, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  transition: opacity ${Transition.Time.BASE};
`;

export const InputContainer = styled.div`
  margin-top: ${Spacing.HALF};
  width: 100%;
`;

export const Input = styled(TextArea).attrs(() => ({
  fluid: true,
  rows: 5,
}))`
  flex: 1 1 100%;
  min-height: ${Spacing.TRIPLE};
  resize: none;
  box-sizing: border-box;
`;

export const Comment = styled.div`
  color: ${Colors.GRAY_DARK_20};
  margin: ${Spacing.SINGLE} 0;
  white-space: pre-wrap;
  ${Font.bySize(Font.Size.XS)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MediaButton = styled(Clickable)`
  align-items: center;
  box-shadow: 0 0 0 1px ${Colors.RADISH};
  border-radius: ${Spacing.DOUBLE};
  color: ${Colors.GRAY_DARK_20};
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: ${Spacing.QUARTER};
  padding: ${Spacing.HALF};
  width: 100%;
  text-decoration: none !important;
  transition: all ${Transition.Time.BASE};

  ${Font.bySize(Font.Size.XXS, Font.Weight.SEMI_BOLD)}
  &:hover {
    box-shadow: 0 0 0 2px ${Colors.BELL_PEPPER_DARK_10};
    color: ${Colors.BELL_PEPPER_DARK_10} !important;
  }

  &:active {
    background: ${Colors.BELL_PEPPER_LITE_30};
  }

  &:visited {
    color: ${Colors.GRAY_DARK_20};
  }
`;

export const PromoCodeText = styled.div`
  background: ${Colors.BELL_PEPPER_LITE_30};
  cursor: default;
  color: ${Colors.BELL_PEPPER_DARK_20};
  margin-top: ${Spacing.SINGLE};
  padding: ${Spacing.SINGLE};
  ${Font.bySize(Font.Size.XS)}
`;
